
import React, { Component } from 'react';
import { formValueSelector, change, Field } from 'redux-form';
import cx from 'classnames';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';

import { FormControl } from 'react-bootstrap';
import { injectIntl, FormattedMessage } from 'react-intl';
import PreferredProviderList from './PreferredProviderList';
import debounce from '../../../../helpers/debounce';
import messages from '../../../../locale/messages';
import Loader from '../../../Common/Loader';
import { getNearestPreferredPartner } from '../../../../actions/siteadmin/ManualBooking/getNearestPreferredPartner';

import NoResult from '/public/Icons/noResult.svg';
import bt from '../../../../components/commonStyle.css';
import s from './SubCategorySlider.css';

class PreferredProviders extends Component {

    constructor(props) {
        super(props)
        this.state = {
            searchList: ''
        }
    }

    handleKeywordSearch = debounce((searchList) => {
        const { userId, lat, lng, subCategoryId, change, getNearestPreferredPartner } = this.props;
        let variables = {
            lat,
            lng,
            userId,
            searchList,
            subCategoryId
        };
        this.setState({ searchList })
        getNearestPreferredPartner(variables, true);
    }, 250);

    render() {
        const { formatMessage } = this.props.intl;
        const { loading, preferredProviders } = this.props;
        return (
            <div className='commonProviderBox'>
                <div className='commonProviderHeading'>{formatMessage(messages.assignProvider)}</div>
                <div className={cx(s.assignProviderSearchInput, 'assignSearchInputRTL')}>
                    <FormControl id="searchList" type="text" placeholder={formatMessage(messages.searchByProviderPhone)} onChange={(e) => this.handleKeywordSearch(e?.target?.value)} className={bt.formControlInput} />
                </div>
                {loading && <div className={cx(bt.spaceTop3, bt.space3)}> <Loader type="circle" show={loading} /></div>}
                {(!loading && preferredProviders?.length > 0) ? <PreferredProviderList nearestProviders={preferredProviders} /> : !loading && <div className='commonNoResultContainer'>
                    <img src={NoResult} />
                    <FormattedMessage {...messages.noProviderAvailable} />
                </div>}
            </div>
        )
    }
}

const selector = formValueSelector('ManualBookingForm');

const mapState = (state) => ({
    loading: state?.booking?.preferredProviderLoading,
    preferredProviders: state?.booking?.preferredProviders,
});

const mapDispatch = {
    change,
    getNearestPreferredPartner
};


export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(PreferredProviders)));

